<template lang="pug">
  section.packageSet
    h1(:class="titleAnimation") 灵活套餐选择
    h2 FLEXIBLE PACKAGE OPTIONS
    article
      h3 高度定制化,满足企业私有化部署需求
      h4 根据您的业务需求及运营，获取生命周期最佳价值，HAMIS OS提供专业解决方案
    div
      div(v-for="(item, _index) in packages" :class="[contentAnimation, `animateDelay-${_index}`]")
        .packageTitle {{ item.title }}
        .options
          .option(v-for="option in item.options")
            span.optionIcon
            span {{ option }}
            
        .checkBoxBuff
          .checkbox(v-for="(ops, index) in opsList")
            .check-box(:class="{isCheck: item.checkOps.indexOf(index) !== -1, isSelectable: item.selectableOps && item.selectableOps.indexOf(index) !== -1}")
            span {{ ops }}
        
        button.customize(@click="gotoPrice") 开始定制
</template>

<script>
  import Mixin from "../../index";
  export default {
    name: "packageSet",
    mixins: [Mixin],
    data() {
      return {
        packages: [
          {title: 'MINI', options: ['包含DATA OPS、AI OPS'], checkOps: [0, 1]},
          {title: 'PRO', options: ['五项OPS自由搭配'], checkOps: [], selectableOps: [0, 1, 2, 3, 4]},
          {title: 'PLUS', options: ['提供运营服务', '包含以下五项OPS'], checkOps: [0, 1, 2, 3, 4]},
        ],
        opsList: ['Data OPS', 'AI OPS', 'IoT OPS', 'MKT OPS', 'Rcmd OPS'],
        contentAnimate: 'animated slideInUp',
      };
    },
    methods: {
      gotoPrice() {
        window.scrollTo(0, 0);
        this.$router.push({name: 'Price'});
      },
    }
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .packageSet {
    width 100%
    padding 100px 0
    display flex
    flex-direction column
    align-items center
    justify-content flex-start
    background-color #f8f8f8
    article {
      margin-bottom 50px
      position relative
      margin-left 95px
    }
  
    h3 {
      font-size 24px
      color #222
      font-weight bold
      margin-bottom 16px
      FontSetting("思源黑体 CN Bold")
      &::before {
        content '"'
        position absolute
        left -60px
        top 0px
        font-size 106px
        color #eae9e9
        font-family Lora
        font-weight 400
      }
    }
  
    h4 {
      font-size 14px
      color #999
      margin-top 16px
      margin-bottom 0
      FontSetting("思源黑体 CN Normal")
    }
  
    > div {
      HStack()
    
      > div {
        border 1px solid #efefef
        height 450px
        width 300px
        box-sizing border-box
        VStack(center, space-between)
        transition all .3s
        background-color #f8f8f8
        margin 0 10px
        &:hover {
          background-color #fff
          border-color transparent
          box-shadow 0 12px 40px 0 #eaeaea
        }
      
        > .packageTitle {
          VStack(center, center)
          margin-top 20px
          margin-bottom 20px
          font-size 32px
          color #269bff
          FontSetting(Montserrat)
          font-weight 200
        
          &::after {
            content ""
            height 2px
            width 38px
            background-color @color
            margin-top 14px
          }
        }
      
        .optionIcon {
          height 20px
          width 20px
          border-radius 50%
          background-color rgba(0, 116, 228, .1)
          position relative
          margin-right 12px
        
          &::after {
            content ""
            height 10px
            width @height
            border-radius 50%
            background-color #0074e4
            position absolute
            bottom 5px
            right 5px
          }
        }
      
        > .options {
          height 56px
          width 100%
          display flex
          flex-direction column
          border-bottom 1px solid #efefef
          padding-bottom 24px
        
          > .option {
            display flex
            align-items center
            justify-content flex-start
            margin-bottom 14px
            margin-left 56px
          
            > span {
              font-size 14px
              color #222222
              FontSetting("思源黑体")
              font-weight 400
            }
          }
        }
      
        .checkBoxBuff {
          width 100%
        }
        .checkbox {
          margin-left 63px
          margin-top 16px
          display flex
        
          .check-box {
            width 12px
            height 12px
            border-radius 2px
            border 1px solid
            border-color #d0d0d0
            background-color #f7f7f7
            margin-right 12px
          }
  
          .isSelectable {
            border-color  #37c978
          }
          
          > span {
            font-size 13px
            color #666666
            font-weight bold
            FontSetting(Montserrat)
          }
        
          .isCheck {
            border-radius 0
            border-color transparent
            background-color transparent
            position relative
          
            &::before, &::after {
              content ""
              height 2px
              background-color #42cc7f
              position absolute
              bottom 0
            }
          
            &::before {
              width 8.48px
              transform rotate(45deg)
              left -2px
              bottom -1px
            }
          
            &::after {
              width 14.14px
              transform rotate(-45deg)
              right -5px
              bottom 1px
            }
          }
        }
      
        .customize {
          outline 0
          width 238px
          height 38px
          margin 20px auto
          border 1px solid #269bff
          border-radius 19px
          background-color transparent
          box-sizing border-box
          color #269bff
          font-size 14px
          transition all .3s
          &:hover {
            background-color #269bff
            color white
          }
        }
      }
      @media (max-width 980px) {
        max-width 100%
        HStack(center, center)
        flex-wrap wrap
        > div {
          margin 10px
        }
      }
    }
    @media (max-width screenWidth) {
      width 100vw
      padding 50px 0
      article {
        margin-left 44px
        padding 0 10px
        margin-bottom 20px
      }
      h2 {
        margin-bottom 0
      }
      h3 {
        font-size 18px
        margin-top 6px
        &::before {
          left -34px
          top -23px
        }
      }
      > div {
        width 100%
        overflow auto
        HStack()
        flex-wrap nowrap
        > div {
          flex-shrink 0
          background-color white
          border-color transparent
          height max-content
          margin 10px
          .customize {
            background-color #269bff
            color white
          }
          .packageTitle {
            margin-top 8px
            margin-bottom 8px
            &::after {
              margin-top 2px
            }
          }
          .options {
            padding-bottom 10px
          }
          .customize {
            margin 8px auto
          }
        }
      }
    }
  }
</style>
